import "./ImagesSector.css"

function ImagesSector(){
    return(
        <div className="ceoImage">
            <img src="/yo_bien_puesto.png" alt="Una descripción de la imagen"></img>
            <div className="ceoPresentation">
                <h2>Detras De TecnoDev</h2>
                <p>TecnoDev tiene como rostro a Federico Tulio Rengel Liacoplo, su director ejecutivo y CEO</p>
            </div>
        </div>
    )
}

export default ImagesSector